import React, { useEffect, useRef, useState } from 'react';
import { TextField, Select, FormControl, InputLabel, withStyles, OutlinedInput, InputAdornment, IconButton, Tooltip } from '@material-ui/core';
import InputMask from "react-input-mask";
import { Autocomplete } from '@material-ui/lab';
import { Close, CloseOutlined } from '@material-ui/icons';
import ButtonCore from './button';
import Spacer from './spacer';
import colors from '../../utils/colors';

const StyledTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderRadius: 8
            },
            '&.Mui-focused fieldset': {
                borderColor: colors?.primary,
            },
        },
        '& .MuiInputLabel-outlined.Mui-focused': {
            color: '#707072',
        },
    },
})(TextField);

const StyledOutlinedInput = withStyles({
    root: {
        backgroundColor: 'transparent',
        '& .MuiOutlinedInput-notchedOutline': {
            borderRadius: 8,
            borderColor: 'rgba(0, 0, 0, 0.23)',
            backgroundColor: 'transparent',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: colors?.primary,
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: colors?.primary,
        },
    },
})(OutlinedInput);

const StyledInputLabel = withStyles({
    root: {
        '&.Mui-focused': {
            color: colors?.primary,
        },
        '&.MuiFormLabel-filled': {},
    },
})(InputLabel);

const Input = props => {

    const [fileName, setFileName] = useState("");
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setFileName(file.name); // Atualiza o nome do arquivo no estado
            if (props.onChange) {
                props.onChange(file); // Passa o arquivo para o callback
            }
        }
    };
    
    const handleClear = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Limpa o valor do input
        }
        setFileName(""); // Limpa o nome do arquivo no estado
        if (props.onClear) {
            props.onClear(); // Callback opcional
        }
    };

    function handleChange(event, value) {
        if(props.onChange){
            props.onChange(event, value);
        }
    }

    function handleBlur(event) {
        if(props.onBlur){
            props.onBlur(event);
        }
    }

    const [maskDesign, setMaskDesign] = useState('');

    useEffect(() => {

        let maskDefination = '';
    
        if(props.mask){
            if(props.mask === 'cep'){
                maskDefination = '99999-999';
            }
            if(props.mask === 'amount'){
                maskDefination = '99';
            }
            if(props.mask === 'number'){
                if(props.maxNumbers){
                    maskDefination = '';
                    for(var i = 1; i <= props.maxNumbers; i++){
                        maskDefination = maskDefination + '9';
                    }
                }else{
                    maskDefination = '99999999';
                }
            }
            if(props.mask === 'creditCardNumber'){
                maskDefination = '99999999999999999';
            }
            if(props.mask === 'creditCardValidate'){
                maskDefination = '99/9999';
            }
            if(props.mask === 'creditCardCvv'){
                maskDefination = '9999';
            }
            if(props.mask === 'cellphone'){
                maskDefination = '(99) 99999-9999';
            }
            if(props.mask === 'date'){
                maskDefination = '99/99/9999';
            }
            if(props.mask === 'cpf'){
                maskDefination = '999.999.999-99';
            }
            if(props.mask === 'cnpj'){
                maskDefination = '99.999.999/9999-99';
            }
        }
    
        setMaskDesign(maskDefination);
    
    }, [props.mask])

    return (
        <>

            {props.type == 'select' ?

                <FormControl 
                    variant="outlined" 
                    size={props.size || 'large'}
                    fullWidth={props.fullWidth}
                    disabled={props.disabled}
                >
                    <StyledInputLabel 
                        shrink={props.options[0]?.label || props?.value || props?.shrink && true}
                    >
                        {props.label}
                    </StyledInputLabel>
                    <Select
                        native
                        value={props.value}
                        onChange={handleChange}
                        input={<StyledOutlinedInput label={props.label} />}
                        label={props.label}
                        id={props?.id}
                        style={{
                            ...props?.style
                        }}
                    >
                        {props?.withCategory ?
                            <>
                                <option aria-label="None" value="" />
                                {props?.options?.map((option) => (
                                    <>
                                        <optgroup index={option?.category} label={option?.category}>
                                            {option?.options?.map((option) => (
                                                <option key={option?.value} value={option?.value}>
                                                    {option?.label}
                                                </option>
                                            ))}
                                        </optgroup>
                                    </>
                                ))}
                            </>
                        :
                            <>
                                {props.options.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </>
                        }
                    </Select>
                </FormControl>

            : props.type === 'autocomplete' ?

                <Autocomplete
                    size={props?.size || 'large'}
                    options={props?.options}
                    getOptionLabel={(option) => option.label}
                    fullWidth={props.fullWidth}
                    onChange={handleChange}
                    value={props?.value} 
                    renderInput={(params) => 
                        <StyledTextField 
                            {...params} 
                            label={props?.label} 
                            variant="outlined" 
                        />
                    }
                />

            : props.mask ? 

                <InputMask 
                    mask={maskDesign}
                    maskChar={null}
                    value={props.value} 
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    {() => 
                        <StyledTextField
                            fullWidth={props.fullWidth}
                            label={props.label}
                            variant="outlined"
                            type={props.type ?? props.type}
                            sx={{ input: { backgroundColor: '#FFF', borderRadius: '8px' } }}
                            inputProps={props.inputProps}
                            disabled={props.disabled}
                            disableUnderline
                            size={props.size || 'large'}
                            InputLabelProps={{
                                shrink: props.value || props?.value === 0
                            }}
                            style={{
                                ...props?.style
                            }}
                        />
                    }
                </InputMask>

            : props?.type == 'file' ?

                <div>
                    <StyledTextField
                        fullWidth={props.fullWidth}
                        label={props.label || "Selecione um arquivo"}
                        variant="outlined"
                        value={fileName}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    {fileName && (
                                        <>
                                            <Tooltip title="Remover arquivo">
                                                <IconButton size="small" onClick={handleClear}>
                                                    <CloseOutlined style={{ fontSize: '20px' }} />
                                                </IconButton>
                                            </Tooltip>
                                            <Spacer direction="horizontal" size={10} />
                                        </>
                                    )}
                                    <ButtonCore
                                        variant="outlined"
                                        size="small"
                                        onClick={() => fileInputRef.current?.click()}
                                        label="Selecionar Arquivo"
                                        style={{ border: 'none', padding: '0px' }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                        disabled
                        InputLabelProps={{
                            shrink: props.value || props?.value === 0 || fileName
                        }}
                        style={{
                            ...props?.style,
                        }}
                    />
                    {/* Input oculto */}
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        {...props.inputProps} // Passa as props para o input file
                    />
                </div>

            :

                <StyledTextField
                    fullWidth={props.fullWidth}
                    label={props.label}
                    variant="outlined"
                    type={props?.type}
                    sx={{ input: { backgroundColor: '#FFF', borderRadius: '8px' } }}
                    value={props.value} 
                    onChange={handleChange}
                    onBlur={handleBlur}
                    inputProps={props.inputProps}
                    multiline={props.multiline ? true : false}
                    minRows={props.multiline ? props.rows : 0}
                    maxRows={props.multiline ? props.rows : 0}
                    disabled={props.disabled}
                    size={props.size || 'large'}
                    InputLabelProps={{
                        shrink: !!props.value || props.type == 'date' || props?.value === 0 || props?.type == 'datetime-local'
                    }}
                    onKeyDown={(event) => {
                        if (props?.type === "number" && !/[0-9]/.test(event.key) && event.key !== "Backspace" && event.key !== "Delete") {
                            event.preventDefault();
                        }
                    }}
                    style={{
                        ...props?.style
                    }}
                    InputProps={{
                        endAdornment: (props?.endAdornment && props?.value) ? (
                            <InputAdornment position="end">
                                <IconButton 
                                    size="small" 
                                    onClick={() => {
                                        props?.onClickEndAdornment();
                                    }}
                                >
                                    <Close style={{ fontSize: '20px' }} />
                                </IconButton>
                            </InputAdornment>
                        ) : null
                    }}
                />
                
            }
            
        </>
    );
}

export default Input;